
import React, {Component} from 'react';
import { withRouter } from "react-router-dom";
import auth0Client from '../Auth';
import axios from 'axios';
import {SERVER_URL} from '../Constants';

class Intro extends Component {
    constructor(props) {
      super(props);
  
      this.state = {
        questions: null,
        checkingSession: true,
        name: '',
        url : '',
        base64Icon:'',
        venueName:'Not Logged In'
      };
    }


    async componentDidMount() {
       
       // this.loadVenue();

        
    }

    loadVenue=()=>{
        if (auth0Client.isAuthenticated()){
            console.log('load venue: ' + auth0Client.getActiveVenuedId());
            axios.get(`${SERVER_URL}/venue/` + auth0Client.getActiveVenuedId(),{
                headers: { 'Authorization': `Bearer ${auth0Client.getIdToken()}` }
              }).then((res)=>{
                const venue = res.data;
                this.setState({
                  name: venue.name,
                  base64Icon: venue.base64Icon,
                 
                });
              }).catch((e)=>{ 
                //console.log("error " + e)
                //ToastStore.error("An error occured. Please try again. error: " + e.message);
              });
        }
    }

    // sign in the user
    signIn =()=>{
        console.log('dashboard');
        this.props.history.push('/Dashboard');
    }






    render() {
        return(
           
            <div style={{'textAlign': 'center'}} > 
  <br/><br/><br/>
           <h3> Welcome To <b>BOUNTE</b>&trade; </h3>
            <br/>

<br/><br/><br/>

            <div className='row' style={{'textAlign': 'center'}} >
                 <div className='col-12'>
                 {
                    !auth0Client.isAuthenticated() &&
                    <button className="btn btn-dark" onClick={() => {this.signIn()}}>Sign In</button>
                  }
                  {
                    auth0Client.isAuthenticated() &&
                    <div>
                       
                       <img style={{width: '220px', height:'200px'}} src={this.props.base64Icon} alt=''/> 
                       <br/><br/><hr/>
                       <h6 className="text-info">{this.props.venueName}</h6>
                       <br/><br/>
                     <p className='text-primary'>you are logged in as user: {auth0Client.getProfile().name }</p>
                   
                    </div>
                  }
                </div>
            </div>
            <div style={{'textAlign': 'center'}}>
               
            <br/><br/>
            <div className='row' style={{'textAlign': 'center'}} >
                 <div className='col-12'>

                    <p className="card-text">
                    <br/><br/><br/><br/>
                    Download the Mobile app 
                    <br/><br/>
                    <a href='https://itunes.apple.com/us/app/bounte/id1262003089?mt=8'> <img style={{width: '120px', height:'40px'}} src='../../images/AppleStore.png' alt='Apple Mobile store'></img> </a>
                       
                        <a href='https://play.google.com/store/apps/details?id=com.bounte'> <img style={{width: '145px', height:'60px'}} src='../../images/GoogleStore.png' alt='Google Play'></img> </a>
                    
                    </p>
                </div>
             </div>
             <br/><br/><br/>  <br/><br/><br/>    
                           
            </div>
                   


                </div>
               
         
           
            
        )
       
    }




}


export default withRouter(Intro);
